import React from 'react';

const ArticlePage = () => {
  return <h1>Liebe dich! xxx</h1>;
};

export default ArticlePage;
